import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.PageContent.RequestVersionHistory', {
    firstPanelTitle: 'Version history',
    secondPanelTitle: 'Version #{version}, {date}',
});
